import { render, staticRenderFns } from "./Red.vue?vue&type=template&id=46e1d70f&"
import script from "./Red.vue?vue&type=script&lang=js&"
export * from "./Red.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports